(function (window, $) {

    'use strict';

    if (!$) {
        return;
    }

    var reducedMotion = Boolean(
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    function initNavigation() {

        var $nav = $('.bmh-nav').first();
        var $toggle = $('[data-bmh-nav-toggle]').first();
        var $menu = $('[data-bmh-nav-menu]').first();
        var $sectionLinks = $('[data-bmh-section-link]');
        var $homeLink = $('[data-bmh-home-link]').first();
        var ticking = false;

        function closeMenu() {
            $menu.removeClass('is-open');
            $toggle.attr('aria-expanded', 'false');
        }

        function stickyOffset() {
            return $nav.length ? $nav.outerHeight() + 12 : 12;
        }

        function setActive($active) {

            var activeNode = $active.length ? $active[0] : null;

            $homeLink
                .toggleClass(
                    'is-active',
                    Boolean(activeNode && $homeLink[0] === activeNode)
                )
                .removeAttr('aria-current');

            if (activeNode && $homeLink[0] === activeNode) {
                $homeLink.attr('aria-current', 'page');
            }

            $sectionLinks.each(function () {

                var $link = $(this);

                var isActive = Boolean(
                    activeNode &&
                    $link[0] === activeNode
                );

                $link
                    .toggleClass('is-active', isActive)
                    .removeAttr('aria-current');

                if (isActive) {
                    $link.attr('aria-current', 'location');
                }

            });
        }

        function updateActiveSection() {

            var offset =
                $(window).scrollTop() +
                stickyOffset() +
                70;

            var $active = $homeLink;

            $sectionLinks.each(function () {

                var $link = $(this);
                var selector = $link.attr('href');

                if (
                    !selector ||
                    selector.charAt(0) !== '#'
                ) {
                    return;
                }

                var $section = $(selector).first();

                if (
                    $section.length &&
                    $section.offset().top <= offset
                ) {
                    $active = $link;
                }

            });

            setActive($active);

            ticking = false;
        }

        function scheduleScrollSpy() {

            if (ticking) {
                return;
            }

            ticking = true;

            window.requestAnimationFrame(
                updateActiveSection
            );
        }

        $toggle
            .off('click.bmhNav')
            .on('click.bmhNav', function () {

                var open = $menu
                    .toggleClass('is-open')
                    .hasClass('is-open');

                $toggle.attr(
                    'aria-expanded',
                    String(open)
                );

            });

        $(document)
            .off('keydown.bmhNav')
            .on('keydown.bmhNav', function (event) {

                if (event.key === 'Escape') {
                    closeMenu();
                }

            });

        $sectionLinks
            .off('click.bmhNav')
            .on('click.bmhNav', function (event) {

                var $link = $(this);
                var selector = $link.attr('href');

                if (
                    !selector ||
                    selector.charAt(0) !== '#'
                ) {
                    return;
                }

                var $target = $(selector).first();

                if (!$target.length) {
                    return;
                }

                event.preventDefault();

                var top = Math.max(
                    0,
                    $target.offset().top -
                    stickyOffset()
                );

                if (reducedMotion) {

                    window.scrollTo(0, top);

                } else {

                    $('html, body')
                        .stop(true)
                        .animate(
                            {
                                scrollTop: top
                            },
                            450
                        );

                }

                closeMenu();

            });

        window.addEventListener(
            'scroll',
            scheduleScrollSpy,
            { passive: true }
        );

        window.addEventListener(
            'resize',
            scheduleScrollSpy,
            { passive: true }
        );

        updateActiveSection();
    }


    function initUrgentTicker() {

        var $viewport = $(
            '[data-bmh-urgent-viewport]'
        ).first();

        var $track = $(
            '[data-bmh-urgent-track]'
        ).first();

        var $group = $(
            '[data-bmh-urgent-group]'
        ).first();

        if (
            !$viewport.length ||
            !$track.length ||
            !$group.length
        ) {
            return;
        }

        var $previous = $(
            '[data-bmh-urgent-prev]'
        ).first();

        var $next = $(
            '[data-bmh-urgent-next]'
        ).first();

        var $play = $(
            '[data-bmh-urgent-play]'
        ).first();

        var $playIcon = $play
            .find(
                '[data-bmh-urgent-play-icon], i'
            )
            .first();

        var state = {
            offset: 0,
            width: 0,
            manualPaused: false,
            hoverPaused: false,
            dragging: false,
            dragMoved: false,
            suppressClick: false,
            pointerId: null,
            pointerStart: 0,
            offsetStart: 0,
            lastFrame: window.performance.now(),
            ready: false,
            resizeTimer: null,
            jumpTimer: null
        };

        var speed = 0.04;

        // Hold still on load so the newest notice can be read, matching the gallery
        // (2s delayed init + 2s autoplay delay).
        var startDelay = 4000;
        var startAt = window.performance.now() + startDelay;

        function applyTransform() {

            $track.css(
                'transform',
                'translate3d(' +
                state.offset +
                'px,0,0)'
            );
        }

        function normalizeOffset() {

            if (!state.width) {
                return;
            }

            while (state.offset > 0) {
                state.offset -= state.width;
            }

            while (state.offset < -state.width) {
                state.offset += state.width;
            }
        }

        function measure() {

            state.width = $group.outerWidth();

            if (!state.width) {
                state.ready = false;
                return;
            }

            // state.offset = -state.width; // _delbk: showed oldest notices first

            // Items are rendered oldest -> newest; start with the newest at the right edge
            // so it is read first as the ticker moves right (RTL).
            state.offset = ($viewport.innerWidth() || 0) - state.width;

            normalizeOffset();

            applyTransform();

            state.ready = true;
        }

        function frame(now) {

            var delta = Math.min(
                42,
                now - state.lastFrame
            );

            state.lastFrame = now;

            if (
                state.ready &&
                now >= startAt &&
                !state.manualPaused &&
                !state.hoverPaused &&
                !state.dragging &&
                !reducedMotion
            ) {

                state.offset += speed * delta;

                normalizeOffset();

                applyTransform();
            }

            window.requestAnimationFrame(frame);
        }

        function setPause(paused) {

            state.manualPaused = paused;

            $playIcon
                .toggleClass(
                    'fa-pause',
                    !paused
                )
                .toggleClass(
                    'fa-play',
                    paused
                );

            $play.attr({
                'aria-label':
                    paused
                        ? 'Start urgent notices'
                        : 'Pause urgent notices',
                'aria-pressed':
                    String(paused)
            });
        }

        function jump(amount) {

            state.hoverPaused = true;

            state.offset += amount;

            normalizeOffset();

            applyTransform();

            window.clearTimeout(
                state.jumpTimer
            );

            state.jumpTimer =
                window.setTimeout(
                    function () {
                        state.hoverPaused = false;
                    },
                    550
                );
        }

        window.requestAnimationFrame(
            function () {
                window.requestAnimationFrame(
                    measure
                );
            }
        );

        window.requestAnimationFrame(frame);

        // The Urdu web font changes item widths once it loads; re-anchor the newest notice.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(measure);
        }

        $(window)
            .off('resize.bmhUrgent')
            .on(
                'resize.bmhUrgent',
                function () {

                    state.ready = false;

                    window.clearTimeout(
                        state.resizeTimer
                    );

                    state.resizeTimer =
                        window.setTimeout(
                            measure,
                            120
                        );
                }
            );

        $viewport
            .off('.bmhUrgent')
            .on(
                'mouseenter.bmhUrgent focusin.bmhUrgent',
                function () {
                    state.hoverPaused = true;
                }
            )
            .on(
                'mouseleave.bmhUrgent focusout.bmhUrgent',
                function () {
                    state.hoverPaused = false;
                }
            )
            .on(
                'pointerdown.bmhUrgent',
                function (event) {

                    var original =
                        event.originalEvent;

                    state.dragging = true;
                    state.dragMoved = false;
                    state.suppressClick = false;
                    state.pointerId =
                        original.pointerId;
                    state.pointerStart =
                        original.clientX;
                    state.offsetStart =
                        state.offset;
                }
            )
            .on(
                'pointermove.bmhUrgent',
                function (event) {

                    if (!state.dragging) {
                        return;
                    }

                    var distance =
                        event.originalEvent.clientX -
                        state.pointerStart;

                    if (
                        !state.dragMoved &&
                        Math.abs(distance) < 7
                    ) {
                        return;
                    }

                    if (!state.dragMoved) {

                        state.dragMoved = true;

                        if (this.setPointerCapture) {
                            this.setPointerCapture(
                                state.pointerId
                            );
                        }
                    }

                    event.preventDefault();

                    state.offset =
                        state.offsetStart +
                        distance;

                    normalizeOffset();

                    applyTransform();
                }
            )
            .on(
                'pointerup.bmhUrgent pointercancel.bmhUrgent',
                function () {

                    state.suppressClick =
                        state.dragMoved;

                    state.dragging = false;
                    state.pointerId = null;

                    if (state.suppressClick) {

                        window.setTimeout(
                            function () {
                                state.suppressClick =
                                    false;
                            },
                            0
                        );
                    }
                }
            )
            .on(
                'click.bmhUrgent',
                '.bmh-urgent__item',
                function (event) {

                    if (state.suppressClick) {

                        event.preventDefault();

                        state.suppressClick = false;
                    }
                }
            );

        $previous
            .off('click.bmhUrgent')
            .on(
                'click.bmhUrgent',
                function () {
                    jump(280);
                }
            );

        $next
            .off('click.bmhUrgent')
            .on(
                'click.bmhUrgent',
                function () {
                    jump(-280);
                }
            );

        $play
            .off('click.bmhUrgent')
            .on(
                'click.bmhUrgent',
                function () {

                    setPause(
                        !state.manualPaused
                    );

                }
            );

        setPause(false);
    }


    /*
     * ============================================================
     * GALLERY
     * ============================================================
     *
     * Swiper replaces the previous Slick implementation.
     *
     * Swiper structure:
     *
     * .swiper
     *     .swiper-wrapper
     *         .swiper-slide
     *
     * The Swiper bundle must already be loaded before this file.
     * ============================================================
     */

    function initGallery() {

        $('[data-bmh-gallery]').each(
            function () {

                var $gallery = $(this);

                var sliderElement =
                    $gallery
                        .find(
                            '[data-bmh-gallery-slider]'
                        )
                        .first()[0];

                if (!sliderElement) {
                    return;
                }

                /*
                 * Prevent duplicate initialization.
                 */
                if (
                    sliderElement.swiper &&
                    !sliderElement.swiper.destroyed
                ) {

                    $gallery.addClass(
                        'is-initialized'
                    );

                    return;
                }

                /*
                 * Make sure Swiper JS is available.
                 */
                if (
                    typeof window.Swiper !==
                    'function'
                ) {

                    return;
                }

                var $previous = $gallery
                    .find(
                        '[data-bmh-gallery-prev]'
                    )
                    .first();

                var $next = $gallery
                    .find(
                        '[data-bmh-gallery-next]'
                    )
                    .first();

                var $play = $gallery
                    .find(
                        '[data-bmh-gallery-play]'
                    )
                    .first();

                var $playIcon = $gallery
                    .find(
                        '[data-bmh-gallery-play-icon]'
                    )
                    .first();

                var $current = $gallery
                    .find(
                        '[data-bmh-gallery-current]'
                    )
                    .first();

                var $dots = $gallery.find(
                    '[data-bmh-gallery-dot]'
                );

                var manuallyPaused = false;


                /*
                 * ------------------------------------------------
                 * Responsive image activation
                 * ------------------------------------------------
                 */

                function activatePictureSources(index) {

                    $gallery
                        .find(
                            '[data-bmh-gallery-index="' +
                            index +
                            '"] source[data-bmh-srcset]'
                        )
                        .each(function () {

                            var source = this;

                            source.setAttribute(
                                'srcset',
                                source.getAttribute(
                                    'data-bmh-srcset'
                                )
                            );

                            source.removeAttribute(
                                'data-bmh-srcset'
                            );
                        });
                }


                /*
                 * ------------------------------------------------
                 * Lazy image activation
                 * ------------------------------------------------
                 */

                function activateSlideImage(index) {

                    var $slide =
                        $gallery.find(
                            '[data-bmh-gallery-index="' +
                            index +
                            '"]'
                        ).first();

                    if (!$slide.length) {
                        return;
                    }

                    var $image =
                        $slide.find('img').first();

                    if (!$image.length) {
                        return;
                    }

                    var lazySrc =
                        $image.attr(
                            'data-lazy'
                        );

                    var lazySrcset =
                        $image.attr(
                            'data-srcset'
                        );

                    var lazySizes =
                        $image.attr(
                            'data-sizes'
                        );

                    if (lazySrc) {

                        $image.attr(
                            'src',
                            lazySrc
                        );

                        $image.removeAttr(
                            'data-lazy'
                        );
                    }

                    if (lazySrcset) {

                        $image.attr(
                            'srcset',
                            lazySrcset
                        );

                        $image.removeAttr(
                            'data-srcset'
                        );
                    }

                    if (lazySizes) {

                        $image.attr(
                            'sizes',
                            lazySizes
                        );

                        $image.removeAttr(
                            'data-sizes'
                        );
                    }
                }


                /*
                 * Activate current slide and adjacent slides.
                 * This keeps image loading smooth without loading
                 * all gallery images immediately.
                 */
                function prepareSlides(index) {

                    var total =
                        $gallery.find(
                            '.swiper-slide'
                        ).length;

                    var indexes = [
                        index,
                        index + 1,
                        index - 1
                    ];

                    indexes.forEach(
                        function (slideIndex) {

                            if (
                                slideIndex >= 0 &&
                                slideIndex < total
                            ) {

                                activatePictureSources(
                                    slideIndex
                                );

                                activateSlideImage(
                                    slideIndex
                                );
                            }
                        }
                    );
                }


                /*
                 * ------------------------------------------------
                 * Accessibility
                 * ------------------------------------------------
                 */

                function syncSlideFocus() {

                    $gallery
                        .find('.swiper-slide')
                        .each(function () {

                            var $slide =
                                $(this);

                            var isHidden =
                                !$slide.hasClass(
                                    'swiper-slide-active'
                                );

                            if (isHidden) {

                                $slide.attr(
                                    'tabindex',
                                    '-1'
                                );

                            } else {

                                $slide.removeAttr(
                                    'tabindex'
                                );
                            }

                            $slide
                                .find(
                                    'a, button, input, select, textarea, [tabindex]'
                                )
                                .each(function () {

                                    var $control =
                                        $(this);

                                    if (isHidden) {

                                        if (
                                            !$control.attr(
                                                'data-bmh-slide-tabindex'
                                            )
                                        ) {

                                            $control.attr(
                                                'data-bmh-slide-tabindex',
                                                $control.attr(
                                                    'tabindex'
                                                ) || 'none'
                                            );
                                        }

                                        $control.attr(
                                            'tabindex',
                                            '-1'
                                        );

                                        return;
                                    }

                                    var previous =
                                        $control.attr(
                                            'data-bmh-slide-tabindex'
                                        );

                                    if (
                                        previous ===
                                        'none'
                                    ) {

                                        $control.removeAttr(
                                            'tabindex'
                                        );

                                    } else if (previous) {

                                        $control.attr(
                                            'tabindex',
                                            previous
                                        );
                                    }

                                    $control.removeAttr(
                                        'data-bmh-slide-tabindex'
                                    );
                                });
                        });
                }


                /*
                 * ------------------------------------------------
                 * Controls
                 * ------------------------------------------------
                 */

                function updateControls(index) {

                    $current.text(
                        index + 1
                    );

                    $dots
                        .removeClass(
                            'is-active'
                        )
                        .removeAttr(
                            'aria-current'
                        );

                    $dots
                        .eq(index)
                        .addClass(
                            'is-active'
                        )
                        .attr(
                            'aria-current',
                            'true'
                        );

                    syncSlideFocus();

                    window.setTimeout(
                        syncSlideFocus,
                        0
                    );
                }


                /*
                 * ------------------------------------------------
                 * Swiper initialization
                 * ------------------------------------------------
                 *
                 * Creative effect gives a more modern transition
                 * than the previous Slick fade.
                 *
                 * These are standard Swiper API options.
                 * ------------------------------------------------
                 */

                var swiper = new window.Swiper(
                    sliderElement,
                    {

                        /*
                         * One gallery image at a time.
                         */
                        slidesPerView: 1,
                        slidesPerGroup: 1,

                        /*
                         * Wrap last -> first (and first -> last).
                         * `loop` is not used: the cards effect needs
                         * at least 9 slides for loop mode (7 without
                         * rotate), rewind works with any count.
                         */
                        rewind: true,

                        /*effect: 'slicer',

                        slicerEffect: {
                            split: 3
                        },

                        speed: reducedMotion ? 0 : 1000,
                        */
                        /*effect: 'creative',

                        creativeEffect: {
                            prev: {
                                translate: ['-20%', 0, -1],
                                opacity: 0
                            },
                            next: {
                                translate: ['100%', 0, 0],
                                opacity: 0
                            },
                            limitProgress: 2
                        },
                        */
                        effect: 'cards',

                        cardsEffect: {
                            slideShadows: true,
                            rotate: true,
                            perSlideOffset: 12,
                            perSlideRotate: 6
                        },

                        speed: reducedMotion ? 0 : 2000,
                        
                       /*effect: 'cube',

                        cubeEffect: {
                            slideShadows: false,
                            shadow: false,
                            shadowOffset: 20,
                            shadowScale: 0.94
                        },

                        speed: reducedMotion ? 0 : 900,
                        */
                        /*effect: 'coverflow',

                        coverflowEffect: {
                            rotate: 30,
                            stretch: 20,
                            depth: 150,
                            modifier: 5,
                            slideShadows: true
                        },

                        speed: reducedMotion ? 0 : 900,
                        */

                        /*
                         * Automatic slideshow.
                         */
                        autoplay: {
                            delay: 2000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        },

                        /*
                         * Touch / mouse dragging.
                         */
                        allowTouchMove: true,
                        grabCursor: true,

                        /*
                         * Keyboard accessibility.
                         */
                        keyboard: {
                            enabled: true,
                            onlyInViewport: true
                        },

                        /*
                         * Accessibility.
                         */
                        a11y: {
                            enabled: true,
                            prevSlideMessage:
                                'Previous gallery image',
                            nextSlideMessage:
                                'Next gallery image',
                            firstSlideMessage:
                                'This is the first gallery image',
                            lastSlideMessage:
                                'This is the last gallery image',
                            paginationBulletMessage:
                                'Show gallery image {{index}}'
                        },

                        /*
                         * We use our existing custom controls,
                         * therefore Swiper's default arrows/dots
                         * are not created.
                         */
                        navigation: false,
                        pagination: false,

                        /*
                         * Do not automatically calculate height.
                         * Your existing gallery CSS controls height.
                         */
                        autoHeight: false,

                        /*
                         * Important for the existing gallery
                         * structure and links.
                         */
                        watchSlidesProgress: true,

                        /*
                         * Start at first gallery image.
                         */
                        initialSlide: 0,

                        /*
                         * Events.
                         */
                        on: {

                            init: function () {

                                prepareSlides(
                                    this.realIndex
                                );

                                updateControls(
                                    this.realIndex
                                );

                                $gallery.addClass(
                                    'is-initialized'
                                );

                            },

                            slideChangeTransitionStart:
                                function () {

                                    prepareSlides(
                                        this.realIndex
                                    );

                                },

                            slideChange:
                                function () {

                                    updateControls(
                                        this.realIndex
                                    );

                                },

                            slideChangeTransitionEnd:
                                function () {

                                    syncSlideFocus();

                                }
                        }
                    }
                );


                /*
                 * ------------------------------------------------
                 * Previous button
                 * ------------------------------------------------
                 */

                $previous
                    .off(
                        'click.bmhGallery'
                    )
                    .on(
                        'click.bmhGallery',
                        function () {

                            if (
                                swiper &&
                                !swiper.destroyed
                            ) {

                                swiper.slidePrev();
                            }
                        }
                    );


                /*
                 * ------------------------------------------------
                 * Next button
                 * ------------------------------------------------
                 */

                $next
                    .off(
                        'click.bmhGallery'
                    )
                    .on(
                        'click.bmhGallery',
                        function () {

                            if (
                                swiper &&
                                !swiper.destroyed
                            ) {

                                swiper.slideNext();
                            }
                        }
                    );


                /*
                 * ------------------------------------------------
                 * Gallery dots
                 * ------------------------------------------------
                 */

                $dots
                    .off(
                        'click.bmhGallery'
                    )
                    .on(
                        'click.bmhGallery',
                        function () {

                            var index =
                                parseInt(
                                    $(this).attr(
                                        'data-bmh-gallery-dot'
                                    ),
                                    10
                                );

                            if (
                                Number.isNaN(index)
                            ) {
                                return;
                            }

                            if (
                                swiper &&
                                !swiper.destroyed
                            ) {

                                swiper.slideToLoop(
                                    index
                                );
                            }
                        }
                    );


                /*
                 * ------------------------------------------------
                 * Play / Pause
                 * ------------------------------------------------
                 */

                $play
                    .off(
                        'click.bmhGallery'
                    )
                    .on(
                        'click.bmhGallery',
                        function () {

                            if (
                                !swiper ||
                                swiper.destroyed ||
                                !swiper.autoplay
                            ) {
                                return;
                            }

                            manuallyPaused =
                                !manuallyPaused;

                            if (manuallyPaused) {

                                swiper.autoplay.stop();

                            } else {

                                swiper.autoplay.start();
                            }

                            $playIcon
                                .toggleClass(
                                    'fa-pause',
                                    !manuallyPaused
                                )
                                .toggleClass(
                                    'fa-play',
                                    manuallyPaused
                                );

                            $play.attr({

                                'aria-label':
                                    manuallyPaused
                                        ? 'Start gallery'
                                        : 'Pause gallery',

                                'aria-pressed':
                                    String(
                                        manuallyPaused
                                    )
                            });
                        }
                    );


                /*
                 * Initial button state.
                 */
                $playIcon
                    .removeClass('fa-play')
                    .addClass('fa-pause');

                $play.attr({
                    'aria-label':
                        'Pause gallery',
                    'aria-pressed':
                        'false'
                });

            }
        );
    }


    /*
     * ============================================================
     * Gallery initialization delay
     * ============================================================
     */

    function scheduleGalleryInit() {

        var initialized = false;

        var firstImage =
            document.querySelector(
                '[data-bmh-gallery-slider] .bmh-gallery-slide:first-child img'
            );

        function start() {

            if (initialized) {
                return;
            }

            initialized = true;

            initGallery();
        }

        function startAfterDelay() {

            /*
             * Keep the existing delayed initialization.
             */
            setTimeout(
                function () {

                    if (!initialized) {
                        start();
                    }

                },
                2000
            );
        }

        function imageReady() {

            if (
                firstImage &&
                typeof firstImage.decode ===
                'function'
            ) {

                firstImage.decode().then(
                    startAfterDelay,
                    startAfterDelay
                );

                return;
            }

            startAfterDelay();
        }

        if (
            !firstImage ||
            (
                firstImage.complete &&
                firstImage.naturalWidth
            )
        ) {

            imageReady();

            return;
        }

        firstImage.addEventListener(
            'load',
            imageReady,
            { once: true }
        );

        firstImage.addEventListener(
            'error',
            startAfterDelay,
            { once: true }
        );
    }


    function initTabs() {

        $('[data-bmh-tabs]').each(
            function () {

                var $root = $(this);

                var $tabs = $root.find(
                    '[role="tab"]'
                );

                var $panels = $root.find(
                    '[role="tabpanel"]'
                );

                function activate($tab) {

                    var targetId =
                        $tab.attr(
                            'aria-controls'
                        );

                    var targetPanel =
                        document.getElementById(
                            targetId
                        );

                    var panelUrl =
                        $tab.attr(
                            'data-bmh-tab-url'
                        );

                    if (
                        targetPanel &&
                        panelUrl &&
                        targetPanel.getAttribute(
                            'data-bmh-tab-loaded'
                        ) !== 'true' &&
                        targetPanel.getAttribute(
                            'data-bmh-tab-loading'
                        ) !== 'true'
                    ) {

                        targetPanel.setAttribute(
                            'data-bmh-tab-loading',
                            'true'
                        );

                        targetPanel.setAttribute(
                            'aria-busy',
                            'true'
                        );

                        targetPanel.innerHTML =
                            '<p class="bmh-tab-loading" role="status">Loading…</p>';

                        window.fetch(
                            panelUrl,
                            {
                                credentials:
                                    'same-origin',

                                headers: {
                                    'X-Requested-With':
                                        'XMLHttpRequest'
                                }
                            }
                        )
                            .then(
                                function (response) {

                                    if (!response.ok) {
                                        throw new Error(
                                            'Unable to load tab content'
                                        );
                                    }

                                    return response.text();
                                }
                            )
                            .then(
                                function (html) {

                                    targetPanel.innerHTML =
                                        html;

                                    targetPanel.setAttribute(
                                        'data-bmh-tab-loaded',
                                        'true'
                                    );
                                }
                            )
                            .catch(
                                function () {

                                    targetPanel.innerHTML =
                                        '<p class="bmh-empty-state">This information is temporarily unavailable.</p>';
                                }
                            )
                            .then(
                                function () {

                                    targetPanel.removeAttribute(
                                        'data-bmh-tab-loading'
                                    );

                                    targetPanel.removeAttribute(
                                        'aria-busy'
                                    );
                                }
                            );
                    }

                    $tabs.each(
                        function () {

                            var $candidate =
                                $(this);

                            var active =
                                $candidate[0] ===
                                $tab[0];

                            $candidate
                                .toggleClass(
                                    'is-active',
                                    active
                                )
                                .attr(
                                    'aria-selected',
                                    String(active)
                                )
                                .attr(
                                    'tabindex',
                                    active
                                        ? '0'
                                        : '-1'
                                );
                        }
                    );

                    $panels.each(
                        function () {

                            var $panel =
                                $(this);

                            var active =
                                $panel.attr(
                                    'id'
                                ) === targetId;

                            $panel
                                .toggleClass(
                                    'is-active',
                                    active
                                )
                                .attr(
                                    'aria-hidden',
                                    String(!active)
                                );
                        }
                    );
                }

                $tabs.each(
                    function (index) {

                        var $tab = $(this);

                        $tab
                            .off('.bmhTabs')
                            .on(
                                'click.bmhTabs',
                                function () {
                                    activate($tab);
                                }
                            )
                            .on(
                                'keydown.bmhTabs',
                                function (event) {

                                    var key =
                                        event.key;

                                    if (
                                        key !== 'ArrowRight' &&
                                        key !== 'ArrowLeft' &&
                                        key !== 'Home' &&
                                        key !== 'End'
                                    ) {
                                        return;
                                    }

                                    event.preventDefault();

                                    var nextIndex =
                                        index;

                                    if (
                                        key === 'ArrowRight'
                                    ) {

                                        nextIndex =
                                            (
                                                index + 1
                                            ) %
                                            $tabs.length;

                                    } else if (
                                        key === 'ArrowLeft'
                                    ) {

                                        nextIndex =
                                            (
                                                index -
                                                1 +
                                                $tabs.length
                                            ) %
                                            $tabs.length;

                                    } else if (
                                        key === 'Home'
                                    ) {

                                        nextIndex = 0;

                                    } else {

                                        nextIndex =
                                            $tabs.length -
                                            1;
                                    }

                                    var $nextTab =
                                        $tabs.eq(
                                            nextIndex
                                        );

                                    $nextTab.trigger(
                                        'focus'
                                    );

                                    activate(
                                        $nextTab
                                    );
                                }
                            );
                    }
                );
            }
        );
    }


    function initServiceDirectory() {

        $('[data-bmh-service-browser]').each(
            function () {

                var $browser = $(this);

                var $filters = $browser.find(
                    '[data-bmh-service-filter]'
                );

                var $items = $browser.find(
                    '[data-bmh-service-item]'
                );

                var $search = $browser
                    .find(
                        '[data-bmh-service-search]'
                    )
                    .first();

                var $clear = $browser
                    .find(
                        '[data-bmh-service-search-clear]'
                    )
                    .first();

                var $empty = $browser
                    .find(
                        '[data-bmh-service-empty]'
                    )
                    .first();

                var $moreToggle = $browser
                    .find(
                        '[data-bmh-service-more-toggle]'
                    )
                    .first();

                var $moreMenu = $browser
                    .find(
                        '[data-bmh-service-more-menu]'
                    )
                    .first();

                var activeFilter = 'key';
                var searchTerm = '';

                function normalize(value) {

                    return String(value || '')
                        .toLowerCase()
                        .replace(/\s+/g, ' ')
                        .trim();
                }

                function closeMore() {

                    $moreMenu.prop(
                        'hidden',
                        true
                    );

                    $moreToggle.attr(
                        'aria-expanded',
                        'false'
                    );
                }

                function updateActiveFilter() {

                    $filters.each(
                        function () {

                            var $button =
                                $(this);

                            var active =
                                $button.attr(
                                    'data-bmh-service-filter'
                                ) === activeFilter;

                            $button
                                .toggleClass(
                                    'is-active',
                                    active
                                )
                                .attr(
                                    'aria-pressed',
                                    active
                                        ? 'true'
                                        : 'false'
                                );
                        }
                    );

                    var moreActive =
                        $moreMenu.length &&
                        $moreMenu.find(
                            '[data-bmh-service-filter="' +
                            activeFilter +
                            '"]'
                        ).length > 0;

                    $moreToggle.toggleClass(
                        'is-active',
                        moreActive
                    );
                }

                function applyFilters() {

                    var visibleCount = 0;
                    var keyCount = 0;

                    $items.each(
                        function () {

                            var $item =
                                $(this);

                            var tags =
                                normalize(
                                    $item.attr(
                                        'data-service-tags'
                                    )
                                )
                                    .split(' ')
                                    .filter(Boolean);

                            var searchable =
                                normalize(
                                    $item.attr(
                                        'data-service-search'
                                    )
                                );

                            var show;

                            if (
                                activeFilter ===
                                'search'
                            ) {

                                show =
                                    searchTerm !== '' &&
                                    searchable.indexOf(
                                        searchTerm
                                    ) !== -1;

                            } else {

                                show =
                                    tags.indexOf(
                                        activeFilter
                                    ) !== -1;
                            }

                            if (
                                show &&
                                activeFilter ===
                                'key'
                            ) {

                                show =
                                    keyCount < 9;

                                keyCount += 1;
                            }

                            $item.prop(
                                'hidden',
                                !show
                            );

                            if (show) {
                                visibleCount += 1;
                            }
                        }
                    );

                    $empty.prop(
                        'hidden',
                        visibleCount !== 0
                    );

                    $clear.prop(
                        'hidden',
                        searchTerm === ''
                    );
                }

                function selectFilter(filter) {

                    activeFilter =
                        filter || 'key';

                    searchTerm = '';

                    $search.val('');

                    updateActiveFilter();

                    applyFilters();

                    closeMore();
                }

                $filters
                    .off('click.bmhServices')
                    .on(
                        'click.bmhServices',
                        function () {

                            selectFilter(
                                $(this).attr(
                                    'data-bmh-service-filter'
                                )
                            );
                        }
                    );

                $search
                    .off('input.bmhServices')
                    .on(
                        'input.bmhServices',
                        function () {

                            searchTerm =
                                normalize(
                                    $(this).val()
                                );

                            activeFilter =
                                searchTerm === ''
                                    ? 'key'
                                    : 'search';

                            updateActiveFilter();

                            applyFilters();
                        }
                    );

                $clear
                    .off('click.bmhServices')
                    .on(
                        'click.bmhServices',
                        function () {

                            searchTerm = '';

                            activeFilter = 'key';

                            $search
                                .val('')
                                .trigger('focus');

                            updateActiveFilter();

                            applyFilters();
                        }
                    );

                $moreToggle
                    .off('click.bmhServices')
                    .on(
                        'click.bmhServices',
                        function (event) {

                            event.stopPropagation();

                            var open =
                                $moreMenu.prop(
                                    'hidden'
                                );

                            $moreMenu.prop(
                                'hidden',
                                !open
                            );

                            $moreToggle.attr(
                                'aria-expanded',
                                open
                                    ? 'true'
                                    : 'false'
                            );
                        }
                    );

                $(document)
                    .off(
                        'click.bmhServicesMenu keydown.bmhServicesMenu'
                    )
                    .on(
                        'click.bmhServicesMenu',
                        function (event) {

                            if (
                                $moreMenu.length &&
                                !$moreMenu.prop(
                                    'hidden'
                                ) &&
                                !$(event.target)
                                    .closest(
                                        $moreMenu.add(
                                            $moreToggle
                                        )
                                    )
                                    .length
                            ) {

                                closeMore();
                            }
                        }
                    )
                    .on(
                        'keydown.bmhServicesMenu',
                        function (event) {

                            if (
                                event.key ===
                                'Escape'
                            ) {

                                closeMore();
                            }
                        }
                    );

                updateActiveFilter();

                applyFilters();

                $browser.addClass(
                    'is-initialized'
                );
            }
        );
    }


    function initReveal() {

        var $elements = $(
            '.bmh-reveal, .bmh-reveal-stagger'
        );

        if (
            reducedMotion ||
            !(
                'IntersectionObserver' in
                window
            )
        ) {

            $elements.addClass(
                'is-visible'
            );

            return;
        }

        var observer =
            new window.IntersectionObserver(
                function (entries) {

                    $.each(
                        entries,
                        function (index, entry) {

                            if (
                                !entry.isIntersecting
                            ) {
                                return;
                            }

                            $(
                                entry.target
                            ).addClass(
                                'is-visible'
                            );

                            observer.unobserve(
                                entry.target
                            );
                        }
                    );
                },
                {
                    threshold: 0.1,
                    rootMargin:
                        '0px 0px -35px'
                }
            );

        $elements.each(
            function () {
                observer.observe(this);
            }
        );
    }


    function initDeferredEmbeds() {

        var embeds =
            document.querySelectorAll(
                '[data-bmh-deferred-embed]'
            );

        if (!embeds.length) {
            return;
        }

        var observer = null;

        function loadEmbed(embed) {

            if (
                !embed ||
                embed.getAttribute(
                    'data-bmh-deferred-state'
                ) === 'loaded' ||
                embed.getAttribute(
                    'data-bmh-deferred-state'
                ) === 'loading'
            ) {
                return;
            }

            var frame =
                embed.querySelector(
                    '[data-bmh-deferred-frame]'
                );

            if (!frame) {
                return;
            }

            var source =
                frame.getAttribute(
                    'data-src'
                );

            if (!source) {
                return;
            }

            embed.setAttribute(
                'data-bmh-deferred-state',
                'loading'
            );

            frame.addEventListener(
                'load',
                function () {

                    embed.setAttribute(
                        'data-bmh-deferred-state',
                        'loaded'
                    );

                    var placeholder =
                        embed.querySelector(
                            '[data-bmh-deferred-load]'
                        );

                    if (placeholder) {
                        placeholder.hidden = true;
                    }
                },
                {
                    once: true
                }
            );

            frame.hidden = false;

            frame.setAttribute(
                'src',
                source
            );

            frame.removeAttribute(
                'data-src'
            );

            if (observer) {
                observer.unobserve(embed);
            }
        }

        if (
            'IntersectionObserver' in
            window
        ) {

            observer =
                new window.IntersectionObserver(
                    function (entries) {

                        entries.forEach(
                            function (entry) {

                                if (
                                    entry.isIntersecting
                                ) {

                                    loadEmbed(
                                        entry.target
                                    );
                                }
                            }
                        );
                    },
                    {
                        rootMargin:
                            '350px 0px',
                        threshold: 0.01
                    }
                );
        }

        embeds.forEach(
            function (embed) {

                var loadButton =
                    embed.querySelector(
                        '[data-bmh-deferred-load]'
                    );

                if (loadButton) {

                    loadButton.addEventListener(
                        'click',
                        function () {
                            loadEmbed(embed);
                        }
                    );
                }

                if (observer) {

                    observer.observe(
                        embed
                    );

                } else {

                    window.setTimeout(
                        function () {
                            loadEmbed(embed);
                        },
                        5000
                    );
                }
            }
        );
    }


    $(function () {

        if (!window.BMHShellInitialized) {

            initNavigation();

            initUrgentTicker();
        }

        scheduleGalleryInit();

        initTabs();

        initServiceDirectory();

        initReveal();

        initDeferredEmbeds();

        $('.bmh-page').addClass(
            'is-ready'
        );
    });

})(window, window.jQuery);